import React, { useEffect } from 'react';
import {
  Route,
  Switch,
  withRouter,
  useHistory
} from 'react-router-dom';
import classnames from 'classnames';
import { Box, Link, Tooltip } from '@material-ui/core';

// styles
import useStyles from './styles';

// components
import Header from '../Header';
import Sidebar from '../Sidebar';

// pages
import Dashboard from '../../pages/dashboard';
import Clientes from '../../pages/clientes';

// context
import { useLayoutState } from '../../context/LayoutContext';
import LoadingBackdrop from '../Backdrop';
import CadastroCliente from '../../pages/clientes/cadastro';
import Cobrancas from '../../pages/cobrancas';
import CadastroCobrancas from '../../pages/cobrancas/cadastro';
import CobrancaDetalhes from '../../pages/cobrancas/detalhes';
import Produtos from '../../pages/produtos';
import CadastroProduto from '../../pages/produtos/cadastro';
import Falhas from '../../pages/sistema/jobs';
import Error from '../../pages/error/Error';
import Usuarios from '../../pages/usuarios';
import CadastroUsuario from '../../pages/usuarios/cadastro';
import Logs from '../../pages/sistema/logs';
import CobrancaContrato from '../../pages/cobrancas/contrato';
import Faturas from '../../pages/faturas';
import ConfiguracoesBancarias from '../../pages/sistema/configuracoesBancarias';

import logoDev from '../../images/logo-dev.png';

function Layout(props) {
  const classes = useStyles();

  // global
  const layoutState = useLayoutState();

  return (
    <div className={classes.root}>
      <>
        <LoadingBackdrop open={layoutState.loading} />
        <Header history={props.history} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Switch>
            <Route path="/app/dashboard" component={Dashboard} />
            <Route path="/app/clientes" exact component={Clientes} />
            <Route path="/app/clientes/cadastro" exact component={CadastroCliente} />
            <Route path="/app/clientes/cadastro/:id" exact component={CadastroCliente} />
            <Route path="/app/faturas" exact component={Faturas} />
            <Route path="/app/cobrancas" exact component={Cobrancas} />
            <Route path="/app/cobrancas/cadastro" exact component={CadastroCobrancas} />
            <Route path="/app/cobrancas/contrato" exact component={CobrancaContrato} />
            <Route path="/app/cobrancas/:id" exact component={CobrancaDetalhes} />
            <Route path="/app/produtos" exact component={Produtos} />
            <Route path="/app/produtos/cadastro" exact component={CadastroProduto} />
            <Route path="/app/produtos/cadastro/:id" exact component={CadastroProduto} />
            <Route path="/app/sistema/processos" exact component={Falhas} />
            <Route path="/app/sistema/usuarios" exact component={Usuarios} />
            <Route path="/app/sistema/usuarios/cadastro" exact component={CadastroUsuario} />
            <Route path="/app/sistema/usuarios/cadastro/:id" exact component={CadastroUsuario} />
            <Route path="/app/sistema/logs" exact component={Logs} />
            <Route path="/app/sistema/configuracoes-bancarias" exact component={ConfiguracoesBancarias} />

            <Route path="/app/*" component={Error} />
          </Switch>
          <Box
            mt={5}
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            {/* <div>
              <Link
                color="primary"
                href="https://flatlogic.com/"
                target="_blank"
                className={classes.link}
              >
                Flatlogic
              </Link>
              <Link
                color="primary"
                href="https://flatlogic.com/about"
                target="_blank"
                className={classes.link}
              >
                About Us
              </Link>
              <Link
                color="primary"
                href="https://flatlogic.com/blog"
                target="_blank"
                className={classes.link}
              >
                Blog
              </Link>
            </div> */}
            <div>
              <Link
                color="primary"
                href="https://wa.me/5583996800612"
                target="_blank"
                className={classes.link}
              >
                <Tooltip
                  title="Desenvolvido por Fernando Neto"
                  aria-label="dev-fernando"
                  placement="left-center"
                >
                  <img
                    src={logoDev}
                    alt="Fernando"
                    className={classes.dev}
                    aria-label="dev-fernando"
                  />
                </Tooltip>
              </Link>
              {/* <Link
                href="https://www.facebook.com/flatlogic"
                target="_blank"
              >
                <IconButton aria-label="facebook">
                  <Icon
                    path={FacebookIcon}
                    size={1}
                    color="#6E6E6E99"
                  />
                </IconButton>
              </Link>
              <Link
                href="https://twitter.com/flatlogic"
                target="_blank"
              >
                <IconButton aria-label="twitter">
                  <Icon
                    path={TwitterIcon}
                    size={1}
                    color="#6E6E6E99"
                  />
                </IconButton>
              </Link>
              <Link
                href="https://github.com/flatlogic"
                target="_blank"
              >
                <IconButton
                  aria-label="github"
                  style={{ marginRight: -12 }}
                >
                  <Icon
                    path={GithubIcon}
                    size={1}
                    color="#6E6E6E99"
                  />
                </IconButton>
              </Link> */}
            </div>
          </Box>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
